import React, { Component } from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import { selectAccountChecklist } from "reducers/account/checklists";
import ColorPicker from "components/Common/ColorPicker";
import FieldGroup from "components/Common/Forms/FieldGroup";

export class ExtraColorCustomization extends Component {
  onChangeBackgroundColorSlider = hex => {
    this.props.updateChecklistStylesSlider("customBackgroundColor", hex);
  };

  onChangeFontColorSlider = hex => {
    this.props.updateChecklistStylesSlider("customFontColor", hex);
  };

  onChangeHoverColorSlider = hex => {
    this.props.updateChecklistStylesSlider("customHoverStateColor", hex);
  };

  updateChecklistBackgroundColor = input =>
    this.props.updateChecklistStyles("customBackgroundColor", input);

  updateChecklistFontColor = input =>
    this.props.updateChecklistStyles("customFontColor", input);

  updateChecklistHoverColor = input =>
    this.props.updateChecklistStyles("customHoverStateColor", input);

  render() {
    const {
      customBackgroundColor,
      customFontColor,
      customHoverStateColor
    } = this.props;

    return (
      <ColorCustomizationContainer>
        <Header>Custom Color Configuration</Header>
        <FieldGroup title="Background Color" className="configuration-item">
          <ColorPicker
            className="test-background-color"
            color={customBackgroundColor}
            onChangeInput={this.updateChecklistBackgroundColor}
            onChangeSlider={this.onChangeBackgroundColorSlider}
          />
        </FieldGroup>
        <FieldGroup title="Font Color" className="configuration-item">
          <ColorPicker
            className="test-font-color"
            color={customFontColor}
            onChangeInput={this.updateChecklistFontColor}
            onChangeSlider={this.onChangeFontColorSlider}
          />
        </FieldGroup>
        <FieldGroup
          title="Hover Background Color"
          className="configuration-item"
        >
          <ColorPicker
            className="test-hover-color"
            color={customHoverStateColor}
            onChangeInput={this.updateChecklistHoverColor}
            onChangeSlider={this.onChangeHoverColorSlider}
          />
        </FieldGroup>
      </ColorCustomizationContainer>
    );
  }
}

const mapStateToProps = (state, { checklistId }) => {
  const checklist = selectAccountChecklist(state, checklistId);
  const customBackgroundColor =
    (checklist.styles && checklist.styles.customBackgroundColor) || "#ffffff";
  const customFontColor =
    (checklist.styles && checklist.styles.customFontColor) || "#555555";
  const customHoverStateColor =
    (checklist.styles && checklist.styles.customHoverStateColor) || "#eeeeee";

  return {
    customBackgroundColor,
    customFontColor,
    customHoverStateColor
  };
};

export default connect(mapStateToProps)(withTheme(ExtraColorCustomization));

const ColorCustomizationContainer = styled.div`
  border: 2px dashed ${props => props.theme["$gray-3"]};
  border-radius: ${props => props.theme["$border-radius"]};
  padding: 1rem;
  margin-right: 25px;
  margin-top: 1rem;
`;

const Header = styled.h2`
  margin: 0 0 1rem 0 !important;
`;
